import { FC } from "react";
import { useFormContext } from "react-hook-form";
import Trash from "src/components/ui-icons/buttons/Trash";
import CustomCheckbox from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomCheckbox";
import CustomRadio from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomRadio";
import { IAnswer, QUESTION_TYPES } from "src/pages/DashboardPage/acadia/components/Tests/types";

export interface IProps {
  index: number;
  id: string;
  answer: IAnswer;
}

export const AnswersField: FC<IProps> = ({ index, id, answer }) => {
  const { register, watch, setValue } = useFormContext();
  const typeQuestion = watch("TypeQuestion");
  const answersTest = watch("AnswersTest");
  const isQuestionTypeMultiple = typeQuestion === QUESTION_TYPES.MULTIPLE;
  const CustomInput = isQuestionTypeMultiple ? CustomCheckbox : CustomRadio;

  const handleDeleteAnswerClick = () => {
    const updatedAnswers = answersTest.filter((answer: IAnswer) => answer.ID !== id);
    setValue("AnswersTest", updatedAnswers, { shouldValidate: true, shouldDirty: true });
  };

  const handleChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updateAnswers = answersTest.map((answer: IAnswer) => ({
      ...answer,
      IsCorrect: e.target.id === answer.ID.toString() ? !answer.IsCorrect : answer.IsCorrect
    }));
    setValue("AnswersTest", updateAnswers, { shouldValidate: true, shouldDirty: true });
  };

  const handleChangeRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updateAnswers = answersTest.map((answer: IAnswer) => ({
      ...answer,
      IsCorrect: e.target.id === answer.ID.toString() ? true : false
    }));
    setValue("AnswersTest", updateAnswers, { shouldValidate: true, shouldDirty: true });
  };

  return (
    <div>
      <div className="flex mb-5">
        <div className="w-full mr-6">
          <div className="flex justify-between">
            <h3 className="mb-[10px] text-base text-black font-medium">Вариант ответа</h3>
            <span className="text-red text-base font-bold">*</span>
          </div>
          <input
            {...register(`AnswersTest.${index}.Description`, { required: true })}
            className="w-full rounded-md shadow-custom p-[11px] border-[#DFE4EA]"
            type="text"
            placeholder="Введите вариант ответа"
          />
        </div>

        <div className="flex items-end">
          <label className="hover:cursor-pointer bg-white flex gap-[10px] rounded-md shadow-custom p-[14px] mr-5 items-center cursor-pointer select-none text-dark dark:text-white">
            <CustomInput {...register(`AnswersTest.${index}.ID`)} id={id} onChange={isQuestionTypeMultiple ? handleChangeCheckBox : handleChangeRadio} checked={answer.IsCorrect}>
              Правильный ответ
            </CustomInput>
          </label>
          <button onClick={handleDeleteAnswerClick} className="bg-white rounded-md shadow-custom p-[14px] hover:cursor-pointer">
            <Trash />
          </button>
        </div>
      </div>
    </div>
  );
};
